/// <reference types="react" />
/// <reference types="react-dom" />
import * as React from 'react'

type ButtonHTMLAttributes<T> = React.ButtonHTMLAttributes<T>
type ReactNode = React.ReactNode

export type ButtonSize = 'sm' | 'md' | 'lg' | 'icon'
export type ButtonVariant = 'default' | 'outline' | 'destructive' | 'secondary' | 'ghost' | 'link'

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	className?: string
	size?: ButtonSize
	variant?: ButtonVariant
	children?: ReactNode
}

const sizeClasses: Record<ButtonSize, string> = {
	sm: 'h-8 px-3 text-xs',
	md: 'h-9 px-4 text-sm',
	lg: 'h-10 px-8 text-base',
	icon: 'h-9 w-9 p-0',
}

const variantClasses: Record<ButtonVariant, string> = {
	default: 'border-neutral-300 dark:border-neutral-700 bg-white/5 hover:bg-white/10',
	outline: 'bg-transparent hover:bg-white/10 border-neutral-300 dark:border-neutral-700',
	destructive: 'bg-red-500 hover:bg-red-600 border-red-600 text-white dark:bg-red-600 dark:hover:bg-red-700',
	secondary: 'bg-neutral-800 hover:bg-neutral-700 border-neutral-700',
	ghost: 'bg-transparent hover:bg-white/5 border-transparent',
	link: 'bg-transparent border-transparent underline-offset-4 hover:underline',
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	({ children, className = '', size = 'md', variant = 'default', ...p }, ref) => (
		<button
			{...p}
			ref={ref}
			className={`inline-flex items-center gap-1 rounded-lg border ${sizeClasses[size as ButtonSize]} ${variantClasses[variant as ButtonVariant]} ${className}`}
		>
			{children}
		</button>
	)
)
Button.displayName = 'Button'
